import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createAddressThunk } from "../../../reducers/slices/address/thunks/create-address-thunk";
import { editAddressThunk } from "../../../reducers/slices/address/thunks/edit-address-thunk";
import { getAddressListThunk } from "../../../reducers/slices/address/thunks/get-address-list-thunk";
export function useAddressState() {
    const dispatch = useDispatch();
    const { addressList } = useSelector((state) => state.addressState);
    const { user } = useSelector((state) => state.userState);
    const [isAddOpen, setIsAddOpen] = useState(false);
    const [isEditOpen, setIsEditOpen] = useState(false);
    const [isExpanded, setIsExpanded] = useState(true);
    const addresses = useMemo(() => addressList, [addressList]);
    const hasAddress = useMemo(() => !!user?.address, [user]);
    const selectedAddress = useMemo(() => user?.address, [user]);
    const handleAddAddressClicked = useCallback(() => {
        setIsAddOpen(true);
    }, []);
    const handleAddAddressClosed = useCallback(() => {
        setIsAddOpen(false);
    }, []);
    const handleAddAddressCloseClicked = useCallback(() => {
        setIsAddOpen(false);
    }, []);
    const handleEditAddressClicked = useCallback(() => {
        setIsEditOpen(true);
    }, []);
    const handleEditAddressClosed = useCallback(() => {
        setIsEditOpen(false);
    }, []);
    const handleEditAddressCloseClicked = useCallback(() => {
        setIsEditOpen(false);
    }, []);
    const handleSubmitAddAddress = useCallback(async (data) => {
        await dispatch(createAddressThunk({ ...data }));
    }, []);
    const handleSubmitEditAddress = useCallback(async (data) => {
        await dispatch(editAddressThunk({ ...data }));
    }, []);
    const handleToggleExpansion = useCallback(() => {
        setIsExpanded((prevValue) => !prevValue);
    }, []);
    useEffect(() => {
        dispatch(getAddressListThunk());
    }, []);
    return useMemo(() => ({
        addresses,
        handleAddAddressClicked,
        handleAddAddressClosed,
        handleAddAddressCloseClicked,
        handleEditAddressClicked,
        handleEditAddressClosed,
        handleEditAddressCloseClicked,
        handleSubmitAddAddress,
        handleSubmitEditAddress,
        handleToggleExpansion,
        hasAddress,
        isAddOpen,
        isEditOpen,
        isExpanded,
        selectedAddress,
    }), [
        addresses,
        handleAddAddressClicked,
        handleAddAddressClosed,
        handleAddAddressCloseClicked,
        handleEditAddressClicked,
        handleEditAddressClosed,
        handleEditAddressCloseClicked,
        handleSubmitAddAddress,
        handleSubmitEditAddress,
        handleToggleExpansion,
        hasAddress,
        isAddOpen,
        isEditOpen,
        isExpanded,
        selectedAddress,
    ]);
}
